import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { LcTestDetailView, ManualGradeCredit } from '@/types/coaching'
import { GradingSheet } from './GradingSheet'
import { testRowsOf, type GradingSheetRow } from './gradingRows'
import { gradingDraftScope } from '@/hooks/coaching/useGradingDraft'

interface Props {
  test: LcTestDetailView
  canGrade: boolean
  /** 행 1건 저장 — 상위가 `useGradeTestItem({ refreshTests: false })`에 매핑한다. 실패는 reject. */
  saveGrade: (quizId: string, isCorrect: boolean) => Promise<unknown>
  /** 모든 저장 시도 후 1회 — 상위가 테스트 목록 갱신·전 문항 채점 안내를 처리한다. */
  onSaveSettled?: () => void
  onRequestCoaching?: (quizId: string) => void
}

/**
 * 챕터/누적 테스트 채점표 — 문항을 sortOrder 순 O/X 행으로 펼치고,
 * 행 저장을 기존 `POST …/tests/{testId}/grade-item` `{ isCorrect, manualGrade: true }`(answer 없음)에 매핑한다.
 * answer를 보내지 않으므로 기존 학생 답안은 보존되고 정오답만 갱신된다. 백엔드에 partialCredit이 없어 △는 없다.
 */
export function TestGradingSheet({ test, canGrade, saveGrade, onSaveSettled, onRequestCoaching }: Props) {
  const { t } = useTranslation('coaching')
  const rows = useMemo(() => testRowsOf(test), [test])

  const saveRow = async (row: GradingSheetRow, value: ManualGradeCredit) => {
    await saveGrade(row.key, value === 1)
  }

  return (
    <GradingSheet
      draftScope={gradingDraftScope.test(test.testId)}
      testId="test-grading-sheet"
      title={t('gradingMode.sheetTitleTest')}
      rows={rows}
      readOnly={!canGrade}
      allowMarkAllCorrect
      saveRow={saveRow}
      onSaveSettled={onSaveSettled}
      onRequestCoaching={onRequestCoaching}
      emptyMessage={t('test.empty')}
    />
  )
}
